export default __webpack_public_path__ + "static/media/called-to-serve-qr.2c6a2351.svg";